import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyledAiRow } from "../_components/styled/ai/styledAi";
import { AI_TEMPLATE } from "../_utils/routes";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { deleteUserAssets } from "../_actions/sidebarSliderActions";
import axios from "axios";
import { TldrConfirmationModal } from "../_components/common/statelessView";

import { COPIES_ENDPOINT } from "../_actions/endpoints";
import Format from "string-format";
import Textfit from "react-textfit/lib/Textfit";
import {
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  HStack,
  Divider,
} from "@chakra-ui/react";
import {
  FaEllipsisV,
  FaExternalLinkSquareAlt,
  FaPencilAlt,
  FaTrash,
} from "react-icons/fa";
import { withTranslation } from "react-i18next";
import { Clipboard } from "../_utils/copyToClipboard";
import { openUrl } from '@simplified-workspace/shared/util';

class AIFavoriteDocument extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.state = {
      isHovering: false,
      isChecked: false,
      showConfirmationModal: false,
      inProgress: false,
      copyId: null,
      copied: false,
      result: this.props.result,
      favorite: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setState({
        isChecked: this.props.selectedCards.find(
          (item) => item === this.props.result
        ),
      });
    }
  }

  unfavoriteCopy(copy, state) {
    axios
      .patch(
        Format(COPIES_ENDPOINT, copy.id),
        { status: state },
        {
          cancelToken: this.signal.token,
        }
      )
      .then((res) => {
        this.setState({
          result: res.data,
          showConfirmationModal: false,
        });
      })
      .catch((error) => {
        //dispatch(handleHTTPError(error, props));
      });
  }

  render() {
    const { enableCardSelection, workspacePermissionChecks, key, t } =
      this.props;
    const { showConfirmationModal, inProgress, result } = this.state;
    const { canDeleteAIDocumentCopy, canViewAIDocumentCopy } =
      workspacePermissionChecks;
    return (
      <>
        {result.status === "saved" ? (
          <StyledAiRow
            className={""}
            allowOverflow={enableCardSelection}
            key={key}
          >
            <div
              className="thumbnail"
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
            >
              <HStack
                align="center"
                justify="space-between"
                key={`${result.id}_icon`}
              >
                <FaPencilAlt size={18} />

                <div onClick={(e) => e.stopPropagation()}>
                  <Menu isLazy>
                    <MenuButton
                      as={IconButton}
                      icon={<Icon as={FaEllipsisV} />}
                      minW="0"
                      h="0"
                      display="flex"
                      sx={{
                        ":focus": {
                          boxShadow: "none",
                        },
                      }}
                    />
                    <MenuList>
                      <MenuItem py={0}>
                        <Clipboard
                          value={
                            result.payload?.cta
                              ? result.payload.headline +
                                "\n" +
                                result.payload.cta
                              : result.payload.headline
                          }
                          withText={true}
                          variant="unstyled"
                          fullwidth={false}
                        />
                      </MenuItem>
                      {canViewAIDocumentCopy && (
                        <MenuItem
                          icon={<FaExternalLinkSquareAlt />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleOnDocumentClick();
                          }}
                        >
                          {t("open_document")}
                        </MenuItem>
                      )}
                      {canDeleteAIDocumentCopy && (
                        <MenuItem
                          icon={<FaTrash />}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showConfirmationModal: true });
                            //this.unfavoriteCopy(result, "draft");
                          }}
                        >
                          {t("delete_from_fav")}
                        </MenuItem>
                      )}
                    </MenuList>
                  </Menu>
                </div>
              </HStack>
              <Divider
                borderColor="brand.border-color"
                borderWidth="1px"
                opacity={1}
                my={4}
                mx={0}
              />
              <Textfit mode="multi" className="title2">
                {result.payload.headline}
              </Textfit>
              <div className="subtitle" key={`${result.id}_sub`}>
                {result.payload.modified}
              </div>
            </div>
          </StyledAiRow>
        ) : null}

        <TldrConfirmationModal
          customMessage={t("delete_conf")}
          modalFor="document"
          inProgress={inProgress}
          show={showConfirmationModal}
          onHide={(e) => {
            this.setState({
              ...this.state,
              showConfirmationModal: false,
            });
          }}
          onYes={() => {
            this.setState(
              {
                inProgress: true,
              },
              //this.handleDeleteDocument(result.id)
              this.unfavoriteCopy(result, "draft")
            );
          }}
        />
      </>
    );
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleDeleteDocument = (documentId) => {
    const extraProps = {
      type: "document",
      id: documentId,
    };

    this.props.delete(extraProps, this.signal.token).then(() => {
      this.setState({
        showConfirmationModal: false,
      });
    });
  };

  handleOnDocumentClick = () => {
    const { result } = this.props;
    openUrl(Format(AI_TEMPLATE, result.document), "_blank");
  };
}

AIFavoriteDocument.propTypes = {
  result: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isPanelShowing: state.folders.isPanelShowing,
  selectedCards: state.folders.selectedCards,
  subscription: state.subscription,
  workspacePermissionChecks: state?.permissions?.workspacePermissionChecks,
});

const mapDispatchToProps = (dispatch) => ({
  delete: (props, token) => dispatch(deleteUserAssets(props, token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["ai"])(AIFavoriteDocument)));
